export default __webpack_public_path__ + "static/media/graphic-05.1bce4aa4.png";